module.exports = __webpack_public_path__ + "media/images/sandbox/produktfotografie_bsp-85d58342bcaabc96a23b500dc7805f16.jpg";